module.exports = __webpack_public_path__ + "static/oxfam-the-equalizr-0e82fbf2ebe5da9ed652dd36506214b0.jpg";